import { DialogRef, DIALOG_DATA } from '@app/ui/dialog';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'be-modal-messages',
  standalone: true,
  templateUrl: './modal-messages.component.html',
})
export class ModalMessagesComponent {
  readonly _dialog = inject(DialogRef);
  readonly data = inject<any>(DIALOG_DATA);
}
